<h1>{{"gipReqStatList" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Title"}}</h1>
<app-grid-template [columns]="columns" [urlString]="urlString" (action)="action($event)"></app-grid-template>

<button mat-raised-button (click)="backAction()">{{"btn_Back" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "SHORT_TEXT" : "Common"}}</button>